import React, { useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import "moment/locale/es";
import { toast } from "react-toastify";
import { BACKEND } from "../config/configEnvs";
import { FaCalendar, FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import DrawerCotizacionCalendarioPagosDetails from "../components/calendarioPagos/DrawerCotizacionCalendarioPagosDetails";
import multiMonthPlugin from "@fullcalendar/multimonth";
import Tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import { years } from "../utils/rawData/dateValues";


const CalendarioCobranzas = () => {
  const [payments, setPayments] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const [selectedDates, setSelectedDates] = useState({ start: null, end: null });
  const [rangeDates, setRangeDates] = useState({ start: null, end: null });
  const [paymentStatus, setPaymentStatus] = useState("todos");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [trabajadoresList, setTrabajadoresList] = useState([]);
  const [currentTrabajador, setCurrentTrabajador] = useState("0");
  const [currentCot, setCurrentCot] = useState(null);
  const [collapesedList, setCollapsedList] = useState(false);
  const [paises, setPaises] = useState([]);
  const [currencyExchanges, setCurrencyExchanges] = useState({})
  const [serviciosList, setServiciosList] = useState([]);

  const [filterDebts, setFilterDebts] = useState(false);

  const getPaises = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/paises?limit=0`);
      setPaises(response.data.docs);
    } catch (error) {
      toast.error('Error al obtener los países');
    }
  }

  const getCurrencyExchange = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/tiposCambio?limit=0`)
      const currencyExchanges = response.data.docs.reduce((acc, item) => {
        acc[item.moneda] = item.tipoCambio
        return acc
      }, {})
      setCurrencyExchanges(currencyExchanges)
    } catch (error) {
      return false
    }
  }

  const getServicios = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?limit=0`);
      setServiciosList(response.data.docs);
    } catch (error) {
      toast.error('Error al obtener los servicios');
    }
  }

  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION" && user.puesto.toUpperCase() !== "ASISTENTE"

  const [brands, setBrands] = useState([])

  const [client, setClient] = useState("")
  const [priceRange, setPriceRange] = useState({ min: 0, max: Infinity})

  // Marcas filtradas por nombre y por precio
  const filteredPaymentsByBrandName = payments.filter((payment) => {
    const matchesClient = client.length > 1
      ? payment.cotizacion?.cliente?.nombreComercial?.toLowerCase().includes(client.toLowerCase())
      : true;
  
    const matchesPrice = payment.precio >= priceRange.min && payment.precio <= priceRange.max;
  
    return matchesClient && matchesPrice;
  });

  const getBrands = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/marcas?limit=0&sort=createdAt`)
      setBrands(response.data.docs)
    } catch (e) {
      toast.error('Error al obtener las marcas');
    }
  }

  // Rangos de precios para el filtro
  const priceRanges = [
    { label: "Todos", min: 0, max: Infinity},
    { label: "S/. 100 - 500", min: 100, max: 500 },
    { label: "S/. 500 - 1000", min: 500, max: 1000 },
    { label: "S/. 1000 - 2000", min: 1000, max: 2000 },
    { label: "S/. 2000 - 3000", min: 2000, max: 3000 },
    { label: "S/. 3000 - 4000", min: 3000, max: 4000 },
    { label: "S/. 4000 - 5000", min: 4000, max: 5000 },
    { label: "S/. 5000+", min: 5000, max: Infinity },
  ];

  const handlePriceRangeChange = (range) => { // Handler del precio
    setPriceRange({ min: range.min, max: range.max });
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 900px)");
    setIsMobile(mediaQuery.matches);
    const handleMediaQueryChange = (event) => {
      setIsMobile(event.matches);
    };
    mediaQuery.addEventListener("change", handleMediaQueryChange);
    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, []);

  const handleDateSelect = (arg) => {
    setSelectedDates({ start: arg.start, end: arg.end });
    setModalIsOpen(true);
  };

  const getTrabajadores = async () => { // Se obtienen los trabajadores
    try {
      const response = await axios.get(
        `${BACKEND}/api/trabajadores?where[area][equals]=Comercial&limit=0`
      );
      setTrabajadoresList(response.data.docs);
    } catch (error) {
      toast.error('Error al obtener los trabajadores');
    }
  };

  const getMainPayments = async () => { // Payload endpoint
    try {
      // Adjust dates by subtracting 5 hours
      const startDate = new Date(rangeDates.start);
      startDate.setHours(startDate.getHours() - 5);
      
      const endDate = new Date(rangeDates.end);
      endDate.setHours(endDate.getHours() - 5);


      let url = `${BACKEND}/api/pagosCotizaciones?where[and][0][fechaLimite][greater_than_equal]=${startDate.toISOString()}&where[and][1][fechaLimite][less_than_equal]=${endDate.toISOString()}&where[and][2][cotizacion.estado][equals]=Exito&where[and][3][cotizacion.cliente.activoAgencia][not_equals]=true&limit=0`

      if (paymentStatus !== "todos") {
        url += `&where[and][4][pagado][equals]=${paymentStatus}`
      }
      if (currentTrabajador !== "0") {
        url += `&where[and][5][cotizacion.cotizador][equals]=${currentTrabajador}`
      }
      if (filterDebts) {
        url += `&where[and][6][faltaCompromisoPago][equals]=true`
      } else {
        url += `&where[and][6][faltaCompromisoPago][not_equals]=true`
      }

      const response = await axios.get(url)

      //console.log("Payload endpoint: " + response.data.docs.length + " - Total: " + response.data.docs.reduce((acc, payment) => acc + payment.precio, 0))
      setPayments(response.data.docs)
    } catch (error) {
      toast.error("Error al obtener los pagos: " + error)
      console.log("Main payments")
      console.log(error)
    }
  }

  const getMainPaymentsWorker = async () => { // Payload endpoint
    try {
      // Adjust dates by subtracting 5 hours
      const startDate = new Date(rangeDates.start);
      startDate.setHours(startDate.getHours() - 5);
      
      const endDate = new Date(rangeDates.end);
      endDate.setHours(endDate.getHours() - 5);

      let url = `${BACKEND}/api/pagosCotizaciones?where[and][0][fechaLimite][greater_than_equal]=${startDate.toISOString()}&where[and][1][fechaLimite][less_than_equal]=${endDate.toISOString()}&where[and][2][cotizacion.estado][equals]=Exito&where[and][3][cotizacion.cotizador][equals]=${user.id}&limit=0`

      if (paymentStatus !== "todos") {
        url += `&where[and][4][pagado][equals]=${paymentStatus}`
      }
      if (filterDebts) {
        url += `&where[and][6][faltaCompromisoPago][equals]=true`
      } else {
        url += `&where[and][6][faltaCompromisoPago][not_equals]=true`
      }

      const response = await axios.get(url)
      setPayments(response.data.docs);
    } catch (error) {
      toast.error("Error al obtener los pagos: " + error)
      console.log("Main payments worker")
      console.log(error)
    }
  }

  const uniqueBrandsMap = new Map(); // Utilizamos esto para mostrar el total de marcas

  let totalPaymentsPayed = 0 // Total pagado
  let totalPaymentsUnpayed = 0 // Total no pagado
  let totalPayments = 0 // Total

  let totalVerifiedPayments = 0 // Total pagado verificado
  let totalUnverifiedPayments = 0 // Total pagado no verificado

  payments.forEach((payment) => {
    const brandName = payment.cotizacion?.cliente?.nombreComercial; // Extraemos el nombre de la marca

    const amountPayed = payment.precio

    totalPayments += amountPayed

    if (payment.pagado === true) {
      totalPaymentsPayed += amountPayed
    } else {
      totalPaymentsUnpayed += amountPayed
    }

    if (payment.pagoVerificado === true) {
      totalVerifiedPayments += amountPayed
    } else {
      totalUnverifiedPayments += amountPayed
    }
    
    if (brandName && !uniqueBrandsMap.has(brandName)) {
      uniqueBrandsMap.set(brandName, brandName);
    }
  });

  // Convertir el Map a un array para una lista de nombres únicos
  const uniqueBrandNames = Array.from(uniqueBrandsMap.values());

  // const deleteAppointment = async (event) => {
  //   if (window.confirm(`¿ Eliminar ${event.title} ?`)) {
  //     await axios.delete(
  //       `${BACKEND}/api/serviciosCotizacionesCitas/${event.id}`
  //     );

  //     toast.success("Eliminado");
  //     getpayments();
  //   }
  // };

  // Toast de carga
  const toastId = useRef(null);

  const selectEventToGetCot = async (idPagoCot) => {
    try {
      toastId.current = toast.loading("Cargando cotización...");

      const pagoCotizacionResponse = await axios.get(
        `${BACKEND}/api/pagosCotizaciones/${idPagoCot}`
      );
      if (pagoCotizacionResponse.data.cotizacion) {
        const cotizacionResponse = await axios.get(
          `${BACKEND}/api/cotizaciones/${pagoCotizacionResponse.data.cotizacion.id}`
        );

        toast.done(toastId.current);
        setCurrentCot(cotizacionResponse.data);
        setOpenDrawer(true);
      } else {
        toast.done(toastId.current);

        toast.error("No existe cotizacion para este evento");
        return;
      }
    } catch (error) {
      toast.done(toastId.current);
      toast.error("No existe cotizacion para este evento");
    }
  };

  useEffect(() => { // Cuando carga el componente se llama a los trabajadores
    getTrabajadores();
    getPaises()
    getCurrencyExchange()
    getServicios()
  }, []);

  useEffect(() => { // Se llama a la función que definirá que funcion se utiliza basada en el puesto del usuario
    getchPaymentsBasedOnRole();
  }, [rangeDates, paymentStatus, currentTrabajador, user, filterDebts]);

  const getchPaymentsBasedOnRole = async () => { // Selector que llama al fecth dependiendo del tipo de usuario
    if (user?.area) {
      if (
        // user.puesto.toUpperCase() === "JEFE DE PROYECTOS" ||
        // user.puesto.toUpperCase() === "GERENTE GENERAL" ||
        // user.puesto.toUpperCase() === "EJECUTIVO DE CUENTAS" ||
        // user.subarea.toUpperCase() === "ADMINISTRACION" ||
        user.area.toUpperCase() === "ADMINISTRACION"
      ) {
        //await getpaymentsMain()
        await getMainPayments()
      } else {
        //await getpaymentsAverageWorker();
        await getMainPaymentsWorker()
      }
    }
  };

  //// Recreo

  const pagosPorDia = filteredPaymentsByBrandName
  .filter((payment) => payment.cotizacion !== null)
  .map((e) => {
    const fechaLimite = new Date(e?.fechaLimite);
    // No sumes 24 horas aquí, ya que queremos que el evento sea en el día exacto
    const fechaLimiteAjustada = fechaLimite.toISOString().split('T')[0]; // Solo la fecha sin hora
    
    return {
      fecha: fechaLimiteAjustada, // Solo la fecha sin la hora
      precio: e?.precio,
    };
  })
  .reduce((acc, { fecha, precio }) => {
    if (!acc[fecha]) {
      acc[fecha] = 0;
    }
    acc[fecha] += precio;
    return acc;
  }, {});

  const events = [ // Formateo de los eventos para extraer el monto total del día y ordenarlo
    ...Object.keys(pagosPorDia).map((fecha) => {
      return {
        title: `Total: ${parseFloat(pagosPorDia[fecha]).toFixed(0)} ${filteredPaymentsByBrandName[0]?.cotizacion?.moneda}`,
        start: `${fecha}T00:00:00`, // Asegurarse de que sea al inicio del día
        end: `${fecha}T23:59:59`,  // Final del día
        color: "#d3d3d3",  // Gris claro para el fondo
        textColor: "#000000",  // Negro para el texto
        className: "font-semibold text-xs",
        id: `total-${fecha}`,
        order: 0, // Aseguramos que este evento sea primero
      };
    }),

    // Primero, agregar los eventos de pago individuales
    ...filteredPaymentsByBrandName
      .filter((payment) => payment.cotizacion !== null)
      .map((e) => {
        const fechaLimite = new Date(e?.fechaLimite);
        const fechaLimiteAjustada = fechaLimite.toISOString().split('T')[0]; // Solo la fecha
  
        // Construir el desglose de servicios
        let serviciosDesglose = "";
        if (e?.montosServicios && Array.isArray(e.montosServicios) && e.montosServicios.length > 0) {
          const serviciosParts = e.montosServicios
            .filter(ms => ms.monto && ms.monto > 0)
            .map(ms => {
              // Intentar obtener el nombre del servicio
              let servicioNombre = "Servicio desconocido";
              
              // Si servicioId tiene servicio poblado con name
              if (ms?.servicioId?.servicio?.name) {
                servicioNombre = ms.servicioId.servicio.name;
              }
              // Si servicioId tiene servicio como ID, buscar en la lista
              else if (ms?.servicioId?.servicio) {
                const servicioId = typeof ms.servicioId.servicio === 'object' 
                  ? ms.servicioId.servicio.id || ms.servicioId.servicio
                  : ms.servicioId.servicio;
                const servicio = serviciosList.find(s => s.id === servicioId);
                servicioNombre = servicio?.name || `Servicio ${servicioId}`;
              }
              // Si servicioId es un objeto con id
              else if (ms?.servicioId?.id) {
                const servicio = serviciosList.find(s => s.id === ms.servicioId.id);
                servicioNombre = servicio?.name || `Servicio ${ms.servicioId.id}`;
              }
              // Si servicioId es directamente un ID
              else if (ms?.servicioId) {
                const servicioId = typeof ms.servicioId === 'object' ? ms.servicioId.id : ms.servicioId;
                const servicio = serviciosList.find(s => s.id === servicioId);
                servicioNombre = servicio?.name || `Servicio ${servicioId}`;
              }
              
              const monto = parseFloat(ms.monto || 0).toFixed(2);
              return `${servicioNombre} - ${monto}`;
            });
          
          if (serviciosParts.length > 0) {
            serviciosDesglose = ` | ${serviciosParts.join(" | ")}`;
          }
        }

        const monedaSimbolo = e?.cotizacion?.moneda === "PEN" ? "S/. " : "$";
        const clienteNombre = e.cotizacion?.cliente
          ? e?.cotizacion?.cliente?.nombreComercial || e?.cotizacion?.cliente?.razonSocial
          : e?.cotizacion?.leadNombre || e?.cotizacion?.leadCompany;

        // Construir el texto completo para el tooltip con el formato: Moneda - precio - descripcion | servicio1 - monto | servicio2 - monto
        const tooltipContent = serviciosDesglose 
          ? `${e?.cotizacion?.moneda} - ${e?.precio} - ${e?.descripcion}${serviciosDesglose}`
          : `${e?.cotizacion?.moneda} - ${e?.precio} - ${e?.descripcion}`;

        return {
          title: `${e?.cotizacion?.moneda === "PEN" ? "S/. " : "$"} ${e?.precio} - ${
            e.cotizacion?.cliente
              ? e?.cotizacion?.cliente?.nombreComercial || e?.cotizacion?.cliente?.razonSocial
              : e?.cotizacion?.leadNombre || e?.cotizacion?.leadCompany
          }`,
          extendedProps: {
            description: tooltipContent
          },
          start: `${fechaLimiteAjustada}T01:00:00`, // Asegurar que sea después de medianoche
          end: `${fechaLimiteAjustada}T01:00:00`,  // Fin a la misma hora
          color: e?.pagado ? "#e8f5e9" : "#ffebee",
          textColor: e?.pagado ? "#2e7d32" : "#ef5350",
          className: "font-semibold text-xs",
          id: e.id,
          order: 1, // Prioridad normal para eventos individuales
        };
      }),
  ];
  
  //// Data global ////

  const [globalPayments, setGlobalPayments] = useState([])
  const [yearSelected, setYearSelected] = useState("2026")
  const [amounts, setAmounts] = useState([])

  const getGlobalPayments = async () => {
    if (isAdmin) {
      try {

      var url = `${BACKEND}/api/pagosCotizaciones?where[and][0][cotizacion.estado][equals]=Exito&limit=10&where[and][1][cotizacion.cliente.activoAgencia][not_equals]=true`

      if (paymentStatus === "true") {
        url += `&where[and][2][pagado][equals]=true`
      } else if (paymentStatus === "false") {
        url += `&where[and][2][pagado][equals]=false`
      } else {
        url += ``
      }

      // Filtrar pagos que faltaron al compromiso de pago
      if (filterDebts) {
        url += `&where[and][3][faltaCompromisoPago][equals]=true`
      } else {
        url += `&where[and][3][faltaCompromisoPago][not_equals]=true`
      }

      const response = await axios.get(url)
  
      const payments = response.data.docs;
  
      const groupedTotals = payments.reduce((acc, payment) => {
        // Validar la fecha
        const fechaLimite = new Date(payment.fechaLimite);
        
        // Extraer solo año y mes sin modificar la fecha con la zona horaria
        const year = fechaLimite.getUTCFullYear(); // Usar getUTCFullYear() para evitar la conversión a hora local
        const month = fechaLimite.getUTCMonth() + 1; // getUTCMonth devuelve 0-11
        const key = `${year}-${month.toString().padStart(2, '0')}`; // Formato "YYYY-MM"
  
        // Validar el precio
        const precio = parseFloat(payment.precio);
        if (isNaN(precio)) {
          console.warn(`Precio inválido para el pago: ${payment}`);
          return acc; // Ignorar pagos con precio inválido
        }
  
        // Inicializar la clave si no existe
        if (!acc[key]) {
          acc[key] = { total: 0, payments: [] };
        }
  
        // Sumar el precio al total del mes
        acc[key].total += precio;
  
        // Almacenar el pago en el grupo
        acc[key].payments.push(payment);
  
        return acc;
      }, {});
  
      setGlobalPayments(groupedTotals);
      } catch (e) {
        toast.error('Error al obtener los pagos globales');
        console.log("Pagos Globales")
        console.error(e);
      }
    }
  };

  useEffect(() => {
    if (isAdmin) {
      getGlobalPayments()
    }
    getBrands()
  }, [])

  useEffect(() => {
    getGlobalPayments()
  }, [paymentStatus, filterDebts])

  useEffect(() => {
    const monthsToShow = Object.entries(globalPayments)
      .filter(([key]) => key.startsWith(yearSelected)) // Filtrar por el año seleccionado
      .map(([key, value]) => ({ key, ...value })) // Convertir a un array con clave y valores
      .sort((a, b) => {
        // Ordenar por mes
        const monthA = parseInt(a.key.split("-")[1], 10); // Extraer el mes como número
        const monthB = parseInt(b.key.split("-")[1], 10); // Extraer el mes como número
        return monthA - monthB;
      });
  
    setAmounts(monthsToShow);
  }, [yearSelected, globalPayments]);

  return (
    <div className="flex flex-col gap-0.5">

      {/* Despegable de la cotización */}
      <DrawerCotizacionCalendarioPagosDetails
        refetch={getchPaymentsBasedOnRole}
        open={openDrawer}
        dataDrawer={currentCot}
        onClose={() => setOpenDrawer(false)}
        isAdmin={isAdmin}
        paises={paises}
        currencyExchanges={currencyExchanges}
      />

      {/* Header */}
      <div className="flex flex-row px-4 py-1 w-full bg-gray-100 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        <div className="flex flex-row w-full items-center gap-4 justify-between">

          <div className="flex items-center gap-4 py-6">
            <FaCalendar className="text-zinc-700 text-2xl" />
            <h2 className="sm:text-2xl xs:text-lg font-bold text-zinc-700">Calendario de cobranza</h2>
          </div>

          {/* Faltó al compromiso de pago */}
          <div className="flex flex-row items-center justify-center gap-2">
            <span className="text-xs whitespace-nowrap">Faltó compromiso de pago</span>
            <input
              type="checkbox"
              className="rounded-md border-gray-400 hover:cursor-pointer"
              checked={filterDebts}
              onChange={(e) => setFilterDebts(e.target.checked)}
            />
          </div>

        </div>
      </div>

      {/* Totales pagados y verificados*/}
      <div className="flex flex-row justify-between gap-2 items-center justify-center bg-gray-100 px-8 py-1 w-full overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

        <div className="flex text-xs text-center items-center justify-center text-gray-700">
          <span className="text-black font-bold whitespace-nowrap">Total pagado:</span>
          <span className="ml-1 text-gray-700 whitespace-nowrap">S/. {totalPaymentsPayed.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
        </div>

        <div className="flex text-xs text-center items-center justify-center text-gray-700">
          <span className="text-black font-bold whitespace-nowrap">Total no pagado:</span>
          <span className="ml-1 text-gray-700 whitespace-nowrap">S/. {totalPaymentsUnpayed.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
        </div>

        <div className="flex text-xs text-center items-center justify-center text-gray-700">
          <span className="text-black font-bold whitespace-nowrap">Total de pagos:</span>
          <span className="ml-1 text-gray-700 whitespace-nowrap">S/. {totalPayments.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
        </div>

        <div className="flex text-xs text-center items-center justify-center text-gray-700">
          <span className="text-black font-bold whitespace-nowrap">Total verificados:</span>
          <span className="ml-1 text-gray-700 whitespace-nowrap">S/. {totalVerifiedPayments.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
        </div>

        <div className="flex text-xs text-center items-center justify-center text-gray-700">
          <span className="text-black font-bold whitespace-nowrap">Total no verificados:</span>
          <span className="ml-1 text-gray-700 whitespace-nowrap">S/. {totalUnverifiedPayments.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
        </div>
    
      </div>

      {/* Barra de filtros */}
      <div className="flex justify-between gap-2 items-center bg-gray-100 px-2 w-full overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

        <div className="flex flex-row gap-4">
          <div>
            <select
              value={paymentStatus}
              onChange={(e) => setPaymentStatus(e.target.value)}
              id="underline_select"
              className="text-gray-700 bg-white text-xs border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
            >
              <option value="todos">Todos</option>
              <option value="true">Pagado</option>
              <option value="false">No Pagado</option>
            </select>
          </div>

          {(user?.puesto.toUpperCase() === "JEFE DE PROYECTOS" ||
            user?.puesto.toUpperCase() === "GERENTE GENERAL" ||
            user?.puesto.toUpperCase() === "EJECUTIVO DE CUENTAS" ||
            user?.area.toUpperCase() === "ADMINISTRACION") && (
            <div>
              <select
                value={currentTrabajador}
                onChange={(e) => setCurrentTrabajador(String(e.target.value))}
                id="underline_select"
                className="text-gray-700 bg-white text-xs border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="0">Trabajadores</option>
                {trabajadoresList.map((e) => (
                  <option key={e.id} value={e.id}>
                    {" "}
                    {e.name}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className="flex flex-row w-full gap-4">

          <div
            className="flex text-xs text-center items-center w-[40%] mr-4 justify-center text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          >
            <span className="text-green-500 font-bold truncate">Pagados:</span>
            <span className="ml-1">{payments.filter((payment) => payment.pagado === true).length}</span>
          </div>

          <div
            className="flex text-xs text-center items-center w-[40%] mr-4 justify-center text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          >
            <span className="text-red-500 font-bold truncate">No pagados:</span>
            <span className="ml-1">{payments.filter((payment) => payment.pagado === false).length}</span>
          </div>

          <div
            className="flex text-xs text-center items-center w-[40%] mr-4 justify-center text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          >
            <span className="text-blue-500 font-bold truncate">Verificados:</span>
            <span className="ml-1">{payments.filter((payment) => payment.pagoVerificado === true).length}</span>
          </div>

          <div
            className="flex text-xs text-center items-center w-[40%] mr-4 justify-center text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          >
            <span className="text-yellow-500 font-bold truncate">No verificados:</span>
            <span className="ml-1">{payments.filter((payment) => !payment.pagoVerificado).length}</span>
          </div>

          <div
            className="flex text-xs text-center items-center w-[40%] mr-4 justify-center text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          >
            <span className="text-black font-bold truncate">Total de pagos:</span>
            <span className="ml-1">{payments.length}</span>
          </div>

          <div
            className="flex text-xs text-center items-center w-[40%] mr-4 justify-center text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          >
            <span className="text-black font-bold truncate">Total de marcas:</span>
            <span className="ml-1">{uniqueBrandNames.length}</span>
          </div>

          <select 
            onChange={(e) => handlePriceRangeChange(priceRanges[e.target.value])}
            className="text-gray-700 bg-white hover:cursor-pointer text-xs border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
          >
            {priceRanges.map((range, index) => (
              <option key={index} value={index}>
                {range.label}
              </option>
            ))}
          </select>
                  
          <div className="relative">
            <input
              type="text"
              placeholder="Buscar marca"
              className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              value={client}
              onChange={(e) => setClient(e.target.value)}
            />
            {client && (
              <FaTimes
                onClick={() => setClient("")}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
              />
            )}
          </div>
        </div>

      </div>
      
      {/* Ingresos por mes */}
      {isAdmin && (
        <div className="flex justify-center flex-row gap-2 items-center bg-gray-100 px-2 overflow-y-auto flex-grow ">

          <div className="flex items-start justify-start flex-row gap-8">
            <div>
              <select
                value={yearSelected}
                onChange={(e) => setYearSelected(e.target.value)}
                id="underline_select"
                className="text-gray-700 bg-white text-xs border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                {years.map((year) => (
                  <option key={year.value} value={year.value}>
                    {year.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex flex-row gap-2 px-4 overflow-x-auto whitespace-nowrap [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
            {amounts.map((amount) => {
              // Función para obtener el nombre del mes
              const getMonthName = (key) => {
                const monthNames = [
                  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
                ];
                
                const [year, month] = key.split('-'); // Divide la clave en año y mes
                const monthIndex = parseInt(month, 10) - 1; // Ajusta el índice del mes
                return `${monthNames[monthIndex]}`; // Combina el nombre del mes con el año
              };

              return (
                <div className="text-xs" key={amount.key}>
                  {getMonthName(amount.key)} / {" "}
                  <span className={`font-bold truncate ${paymentStatus === "true" ? "text-green-500" : paymentStatus === "false" ? "text-red-500" : "text-black"}`}>
                    {amount.total.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </span>
                </div>

              );
            })}
          </div>
        </div>
      )}

      {/* Body */}
      <div className="flex w-full gap-2">

        {/* Calendario */}
        <div className="px-4 flex-1">

          <FullCalendar
            events={events}
            eventOrder={"order,start,-duration,title"}
            height="75vh"
            datesSet={(e) => {
              const viewStartDate = e.view.currentStart;
              const viewEndDate = e.view.currentEnd;          
              setRangeDates({
                start: viewStartDate.toISOString().split('T')[0], // Fecha de inicio de la vista
                end: viewEndDate.toISOString().split('T')[0],     // Fecha de fin de la vista
              });
            }}           
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
              listPlugin,
              multiMonthPlugin,
            ]}
            moreLinkText={"Ver todos"}
            locale={"es"}
            headerToolbar={{
              start: isMobile ? "prev,next" : "title",
              center:
                !isMobile &&
                "multiMonthYear,dayGridMonth,timeGridWeek,timeGridDay",
              end: isMobile
                ? "multiMonthYear,dayGridMonth,timeGridWeek,timeGridDay"
                : "prev,next",
            }}
            buttonText={{
              today: "Hoy",
              month: "Mes",
              year: "Año",
              week: "Semana",
              day: "Día",
              listMonth: "Agenda del mes",
              listDay: "Agenda hoy",
              timeGrid: "Semana",
            }}
            views={{
              timeGridFourDay: {
                type: "timeGrid",
                duration: { days: 4 },
                buttonText: "Semana",
              },
              timeGridWeek: {
                duration: { days: isMobile ? 4 : 7 },
                buttonText: "Semana",
              },
            }}
            initialView={isMobile ? "timeGridWeek" : "dayGridMonth"}
            moreLinkHint={true}
            defaultAllDay
            dayMaxEvents={false}
            eventContent={function (arg) {
              let containerEl = document.createElement("div");
              containerEl.classList = `event-container cursor-pointer ${
                arg.event.textColor === "#2e7d32"
                  ? " hover:bg-green-200"
                  : " hover:bg-red-200"
              }`;

              let contentEl = document.createElement("p");
              contentEl.classList = "event-content overflow-hidden";

              if (arg.event.extendedProps.isUrgent) {
                contentEl.innerHTML = "urgent event";
              } else {
                contentEl.innerHTML = `${arg.event.title}`;
              }

              containerEl.appendChild(contentEl);

              // Add click event listener
              containerEl.addEventListener("click", async function (event) {
                // Check if the clicked element matches the desired element
                if (event.target.classList.contains("event-content")) {
                  // Perform asynchronous logic
                  await selectEventToGetCot(arg.event.id);
                }
              });

              return { domNodes: [containerEl] };
            }}
            eventDidMount={(info) => {
              Tippy(info.el, {
                content: info.event.extendedProps?.description || info.event.title,
                placement: 'top',
                theme: 'dark',
                animation: 'scale'
              });
            }}
            initialEvents={[]}
          />

        </div>

      </div>
    </div>
  );
};

export default CalendarioCobranzas;
